export default {
  // Inventory
  "no_films_found": "일치하는 필름을 찾을 수 없습니다",
  "no_films_yet": "아직 필름 롤이 없습니다",
  "add_first_film": "첫 번째 필름 추가하기",
  "no_lenses_found": "일치하는 렌즈를 찾을 수 없습니다",
  "no_lenses_yet": "아직 렌즈가 없습니다",
  "add_first_lens": "첫 번째 렌즈 추가하기",
  "no_cameras_found": "일치하는 카메라를 찾을 수 없습니다",
  "no_cameras_yet": "아직 카메라가 없습니다",
  "add_first_camera": "첫 번째 카메라 추가하기",
  "no_items_inventory": "인벤토리에 항목이 없습니다",
  "inventory_management": "인벤토리 관리",
  "film": "필름",
  "cameras": "카메라",
  "lenses": "렌즈",
  "search_films": "필름 검색...",
  "search_lenses": "렌즈 검색...",
  "search_cameras": "카메라 검색...",
  "add_lens": "렌즈 추가",
  "add_film": "필름 추가",
  "add_camera": "카메라 추가",
  "add_new_lens": "새 렌즈 추가",
  "add_new_film": "새 필름 추가",
  "add_new_camera": "새 카메라 추가",
  "add_lens_details": "아래 세부 정보를 입력하여 새 렌즈를 인벤토리에 추가하세요.",
  "add_film_details": "아래 세부 정보를 입력하여 새 필름을 인벤토리에 추가하세요.",
  "add_camera_details": "아래 세부 정보를 입력하여 새 카메라를 인벤토리에 추가하세요.",
  "essential_info": "필수 정보",
  "optional_details": "선택적 세부 정보",
  "brand": "브랜드",
  "lens_name": "렌즈 이름/모델",
  "lens_name_placeholder": "50mm f/1.8, 24-70mm f/2.8 등",
  "brand_placeholder": "니콘, 캐논 등",
  "film_name": "필름 이름",
  "film_name_placeholder": "Portra 400, HP5 Plus 등",
  "camera_name": "카메라 이름/모델",
  "camera_name_placeholder": "AE-1, F3, Leica M6 등",
  "mount": "마운트",
  "mount_placeholder": "예: EF, M42",
  "mount_description": "최대 4개의 영숫자 문자 (예: EF, M42)",
  "status": "상태",
  "select_status": "상태 선택",
  "working": "작동 중",
  "needs_repair": "수리 필요",
  "for_parts": "부품용",
  "serial_number": "일련번호 (선택사항)",
  "purchase_date": "구매 날짜 (선택사항)",
  "purchase_price": "구매 가격 (선택사항)",
  "notes": "메모 (선택사항)",
  "notes_placeholder": "이 물품에 대한 추가 메모",
  "next_step": "다음 단계",
  "update_lens": "렌즈 업데이트",
  "update_film": "필름 업데이트",
  "update_camera": "카메라 업데이트",
  "edit_film": "필름 편집",
  "edit_lens": "렌즈 편집",
  "edit_camera": "카메라 편집",
  "update_film_details": "아래에서 필름 세부 정보 업데이트",
  "update_lens_details": "아래에서 렌즈 세부 정보 업데이트",
  "update_camera_details": "아래에서 카메라 세부 정보 업데이트",
  "delete_film": "필름 삭제",
  "delete_lens": "렌즈 삭제",
  "delete_camera": "카메라 삭제",
  "confirm_delete_film": "다음을 삭제하시겠습니까",
  "confirm_delete_lens": "다음을 삭제하시겠습니까",
  "confirm_delete_camera": "다음을 삭제하시겠습니까",
  "from_your_inventory": "인벤토리에서",
  "action_cannot_undone": "이 작업은 취소할 수 없습니다.",
  "film_removed_inventory": "인벤토리에서 필름이 제거되었습니다",
  "lens_removed_inventory": "인벤토리에서 렌즈가 제거되었습니다",
  "camera_removed_inventory": "인벤토리에서 카메라가 제거되었습니다",
  "failed_delete_film": "필름 삭제 실패",
  "failed_delete_lens": "렌즈 삭제 실패",
  "failed_delete_camera": "카메라 삭제 실패",
  "cannot_delete_film_missing_id": "ID가 없어 필름을 삭제할 수 없습니다",
  "cannot_delete_lens_missing_id": "ID가 없어 렌즈를 삭제할 수 없습니다",
  "cannot_delete_camera_missing_id": "ID가 없어 카메라를 삭제할 수 없습니다",
  "film_updated_successfully": "필름이 성공적으로 업데이트되었습니다",
  "lens_updated_successfully": "렌즈가 성공적으로 업데이트되었습니다",
  "camera_updated_successfully": "카메라가 성공적으로 업데이트되었습니다",
  "error_updating_film": "필름 업데이트 오류",
  "error_updating_lens": "렌즈 업데이트 오류",
  "error_updating_camera": "카메라 업데이트 오류",
  "cannot_update_film_missing_id": "ID가 없어 필름을 업데이트할 수 없습니다",
  "cannot_update_lens_missing_id": "ID가 없어 렌즈를 업데이트할 수 없습니다",
  "cannot_update_camera_missing_id": "ID가 없어 카메라를 업데이트할 수 없습니다",
  "all": "전체",
  "all_film": "모든 필름",
  "all_lenses": "모든 렌즈",
  "all_cameras": "모든 카메라",
  "unexposed": "미노출",
  "fresh": "신품",
  "exposed": "노출됨",
  "expired": "만료됨",
  "developed": "현상됨",
  "transferring": "이전 중:",
  "quantity_expose": "노출할 수량",
  "notes_optional": "메모 (선택사항)",
  "mark_exposed": "노출됨으로 표시",
  "mark_film_exposed": "필름을 노출됨으로 표시",
  "transfer_film_description": "인벤토리에서 노출된 컬렉션으로 필름을 이전합니다.",
  "signin_required_inventory": "인벤토리를 보려면 로그인해야 합니다",
  "film_details": "필름 세부 정보",
  "lens_details": "렌즈 세부 정보",
  "camera_details": "카메라 세부 정보",
  "last_updated": "마지막 업데이트",
  "type": "타입",
  "quantity": "수량",
  "expiration_date": "만료 날짜",
  "expiration": "만료",
  "focal_length": "초점 거리",
  "aperture": "조리개",
  "iso": "ISO",
  "film_type": "필름 유형",
  "color": "컬러",
  "black_and_white": "흑백",
  "slide": "슬라이드",
  "camera_type": "카메라 유형",
  "slr": "SLR",
  "dslr": "DSLR",
  "mirrorless": "미러리스",
  "rangefinder": "레인지파인더",
  "point_and_shoot": "포인트 앤 슈트",
  "instant_film": "인스턴트 필름",
  "compatible_cameras": "호환 카메라",
  "compatible_lenses": "호환 렌즈",
  "compatible_films": "호환 필름",
  "are_you_absolutely_sure": "정말 확실합니까?",
  "model": "모델",
  "error_loading_cameras": "카메라 로딩 오류",
  "camera_added_successfully": "카메라가 성공적으로 추가되었습니다",
  "error_adding_camera": "카메라 추가 오류",
  "adapter_enabled": "어댑터 활성화됨",
  "adapter_mounts": "어댑터 마운트",
  "select_format": "형식 선택",
  "select_camera_type": "카메라 유형 선택",
  "format": "형식",
  "medium_format": "중형 포맷",
  "large_format": "대형 포맷",
};
